import Dropdown from './Dropdown.jsx';
import './Pagination.css';

function getPageNumbers(current, total) {
  if (total <= 5) {
    return Array.from({ length: total }, (_, i) => i + 1);
  }
  const pages = [1];
  const start = Math.max(2, current - 1);
  const end = Math.min(total - 1, current + 1);
  if (start > 2) pages.push('...');
  for (let i = start; i <= end; i++) pages.push(i);
  if (end < total - 1) pages.push('...');
  if (total > 1) pages.push(total);
  return pages;
}

export default function Pagination({
  page,
  totalPages,
  onPageChange,
  infoLabel,
  pageSize,
  pageSizeOptions,
  onPageSizeChange,
}) {
  return (
    <div className="customer-portal-orders-pagination-bar">
      <span className="customer-portal-orders-pagination__label">{infoLabel}</span>

      <div className="customer-portal-orders-pagination__pages">
        <button type="button" disabled={page <= 1} onClick={() => onPageChange(Math.max(1, page - 1))}>‹</button>
        {getPageNumbers(page, totalPages).map((p, idx) =>
          p === '...' ? (
            <span key={`ellipsis-${idx}`} className="customer-portal-orders-pagination__ellipsis">…</span>
          ) : (
            <button
              key={p}
              type="button"
              className={p === page ? 'customer-portal-is-active' : ''}
              onClick={() => onPageChange(p)}
            >
              {p}
            </button>
          )
        )}
        <button type="button" disabled={page >= totalPages} onClick={() => onPageChange(Math.min(totalPages, page + 1))}>›</button>
      </div>

      <div className="customer-portal-orders-pagination__size">
        {pageSizeOptions && (
          <>
            <span className="customer-portal-orders-pagination__size-label">Rows per page</span>
            <Dropdown
              value={String(pageSize)}
              onChange={(v) => onPageSizeChange(Number(v))}
              width="72px"
              options={pageSizeOptions.map((n) => ({ value: String(n), label: String(n) }))}
            />
          </>
        )}
      </div>
    </div>
  );
}
